// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"q_bl container-lg d-flex p-3","doc-page":"q_bm","doc-page__title--enterprise":"q_bn","doc-page--with-side-menu":"q_bp","doc-page__title":"q_bq"};